// React
import React, { useEffect, useState } from "react";
// MUI
import { Card, Stack, Button, Container, Typography, Backdrop } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Components
import GoTable from "../../../common/GoTable/GoTable";
import GoDrawer from "../../../components/Inputs/GoDrawer";
import VoucherLine from "./VoucherLine";
// Constants
import PermissionConstants from "../../../configs/PermissionConstants";
// Hooks
import usePermissions from "../../../hooks/usePermissions";
// Utils
import { voucherTypes } from './Voucher.utils';
import GoDialog from "../../../common/GoDialog/GoDialog";
// Service
import { del } from "../../../services/FetchHelper";
import SpinService from "../../../services/SpinService";
import EntityConstants from "../../../configs/EntityConstants";
import MessageContants from "../../../configs/MessageContants";
import toast from "react-hot-toast";

import { Form, Formik } from "formik";
import { post, put } from "../../../services/FetchHelper";
import { voucherLineTypes } from "./Voucher.utils";
import GoInLineTable from "../../../common/GoInLineTable/GoInLineTable";

const VoucherLines = ({ voucherId, voucherType, voucherLines, reload }) => {
    const spinService = SpinService();
    const permissions = usePermissions();
    const [voucherLineState, setVoucherLineState] = useState(voucherLineTypes[voucherType].state);
    const [allVoucherLines, setAllVoucherLines] = useState([]);
    const [voucherLineId, setVoucherLineId] = useState(undefined);

    const addNew = () => {
        if (allVoucherLines.find((item) => item.rowAction !== undefined && (item.rowAction === "new" || item.rowAction === "edit")) === undefined) {
            const nr = { ...voucherLineTypes[voucherType].state, rowAction: 'new' }
            if (allVoucherLines === false) {
                setAllVoucherLines([nr])
            } else {
                setAllVoucherLines([...allVoucherLines, nr])
            }
            setVoucherLineState(nr);
        }
    };

    const handleSubmit = async (values) => {
        spinService.on();
        const isNewVoucherLine = values.id === undefined;
        if (isNewVoucherLine) {
            values.voucher_id = voucherId;
            values.type = voucherType;
        }
        const url = isNewVoucherLine ? EntityConstants.VOUCHER_LINES : EntityConstants.VOUCHER_LINES + `/${values.id}`;
        const method = isNewVoucherLine ? post : put;
        const response = await method(url, { voucher_line: values });
        if ([200, 201].indexOf(response.status) > -1) {
            toast.success(isNewVoucherLine ? MessageContants.VOUCHER_LINE_CREATED : MessageContants.VOUCHER_LINE_UPDATED);
            onClose();
        }
        spinService.off();
    };

    useEffect(() => {
        if (voucherType !== "Payment Voucher") {
            const updatedList = voucherLines.map((item) => ({ ...item, account_code: item.debit_ledger_code ? item.debit_ledger_code : item.credit_ledger_code, account_name: item.debit_ledger_name ? item.debit_ledger_name : item.credit_ledger_name }));
            setAllVoucherLines(updatedList);
        } else {
            setAllVoucherLines(voucherLines);
        }
    }, [voucherLines]);

    const [open, setOpen] = useState(false);
    const [lines, setLines] = useState([]);
    const [confirm, setConfirm] = useState(false);

    const onClose = () => {
        reload();
        setVoucherLineId(undefined);
        setOpen(false);
    };

    const handleClose = async (res) => {
        if (res) {
            spinService.on();
            const response = await del(EntityConstants.VOUCHER_LINES + `/${voucherLineId}`);
            if (response.status === 200) {
                toast.success(MessageContants.VOUCHER_LINE_DELETED);
            }
            reload();
            spinService.off();
        } else {
            setVoucherLineId(undefined);
        }
        setConfirm(false);
    };

    const onAction = (item, action) => {
        if (action === "edit" && allVoucherLines.find((item) => item.rowAction !== undefined && (item.rowAction === "new" || item.rowAction === "edit")) === undefined) {
            setVoucherLineId(item.id);
            const voucherLine = allVoucherLines.find((row) => row.id === item.id);
            if (voucherType !== "Journal Voucher") {
                setVoucherLineState(voucherLine)
            } else {
                setVoucherLineState({
                    id: voucherLine.id,
                    narration: voucherLine.narration,
                    account_id: voucherLine.debit_ledger_id === null ? voucherLine.credit_ledger_id : voucherLine.debit_ledger_id,
                    credit_amount: voucherLine.credit_amount,
                    debit_amount: voucherLine.debit_amount
                })
            }

            setAllVoucherLines((prevFormFields) => prevFormFields.map(row => row.id === item.id ? { ...voucherLine, rowAction: 'edit' } : row));
        }
        if (action === "delete") {
            setVoucherLineId(item.id);
            setConfirm(true);
            return;
        }
    }

    const onCalcChange = (voucherLines) => {
        const lastRow = voucherLines.reduce((accumulator, currentValue) => {
            return {
                row_type: "total",
                account_code: "Total Amount (AED)",
                credit_amount: currentValue.credit_amount && (Number(accumulator.credit_amount) + Number(currentValue.credit_amount)).toFixed(2),
                debit_amount: currentValue.debit_amount && (Number(accumulator.debit_amount) + Number(currentValue.debit_amount)).toFixed(2),
            }
        }, {
            row_type: "total",
            account_code: "Total Amount (AED)",
            credit_amount: 0,
            debit_amount: 0
        });
        const totalRows = voucherType !== "SplitUp Lines" ? voucherLines.length > 0 && [...voucherLines, lastRow] : voucherLines;
        // if (voucherType === "Payment Voucher") {
        //     totalRows = totalRows.length > 0 && [...totalRows, {
        //         account_code: `Amount in words (AED) : ${convertToWords(lastRow.debit_amount)}`
        //     }];
        // }
        setLines(totalRows);

    };

    const getTitle = () => {
        switch (voucherType) {
            case 'SplitUp Lines':
                return "Split-Up Lines";
            case 'SplitUp':
                return "Split-Up";
            default:
                return `${voucherType} Lines`
        }
    };

    useEffect(() => {
        // if (voucherType !== "Payment Voucher") {
        //     const updatedList = voucherLines.map((item) => ({ ...item, account_code: item.debit_ledger_code ? item.debit_ledger_code : item.credit_ledger_code, account_name: item.debit_ledger_name ? item.debit_ledger_name : item.credit_ledger_name }));
        //     onCalcChange(updatedList);
        // } else {
        //     onCalcChange(voucherLines);
        // }
    }, [voucherLines]);

    return (
        <React.Fragment>
            <Container maxWidth={false}>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    mb={2}
                >
                    <Typography variant="h4" gutterBottom>
                        {getTitle(voucherType)}
                    </Typography>
                    {
                        ((voucherType === "Payment Voucher" && permissions.has(PermissionConstants.PAYMENT_VOUCHER_CREATE)) ||
                            (voucherType === "Journal Voucher" && permissions.has(PermissionConstants.JOURNAL_VOUCHER_CREATE)) ||
                            (voucherType === "PDC Bank Payment" && permissions.has(PermissionConstants.PDC_BANK_PAYMENT_CREATE)) ||
                            ((voucherType === "Prepayment Voucher" || voucherType === "SplitUp") && permissions.has(PermissionConstants.PREPAYMENT_VOUCHER_CREATE))) &&
                        <Button
                            variant="contained"
                            startIcon={<Iconify icon="eva:plus-fill" />}
                            onClick={addNew}
                        >
                            New Line
                        </Button>
                    }
                </Stack>
                <Card>
                    <Formik
                        enableReinitialize
                        initialValues={voucherLineState}
                        validationSchema={voucherLineTypes[voucherType].schema}
                        onSubmit={(values) => handleSubmit(values)}
                    >
                        {({
                            values,
                            touched,
                            errors,
                            handleChange,
                            handleSubmit,
                        }) => (
                            <Form noValidate onSubmit={handleSubmit}>

                                <GoInLineTable
                                    tableHeads={voucherTypes[voucherType].tableHeaders}
                                    tableDatas={allVoucherLines}
                                    onAction={(row, action) => onAction(row, action)}
                                    editRowId={voucherLineId}
                                    formElement={
                                        <VoucherLine
                                            values={values}
                                            touched={touched}
                                            errors={errors}
                                            handleChange={handleChange}
                                            voucherType={voucherType}
                                            voucherId={voucherId}
                                            voucherLineId={voucherLineId}
                                            onClose={() => onClose()}
                                        />
                                    }
                                />
                            </Form>

                        )}
                    </Formik>
                    {/* <GoTable
                        search={false}
                        pagination={false}
                        tableHeads={voucherTypes[voucherType].tableHeaders}
                        tableDatas={lines}
                        totalCount={0}
                        filter={filter}
                        onFilter={(filter) => setFilter(filter)}
                        onView={(row) => { setOpen(true) }}
                        onAction={(row, action) => onAction(row, action)} /> */}
                </Card>
            </Container>
            <Backdrop open={open} />
            {
                ((voucherType === "Payment Voucher" && permissions.has(PermissionConstants.PAYMENT_VOUCHER_VIEW)) ||
                    (voucherType === "Journal Voucher" && permissions.has(PermissionConstants.JOURNAL_VOUCHER_VIEW)) ||
                    ((voucherType === "Prepayment Voucher" || voucherType === "SplitUp") && permissions.has(PermissionConstants.PREPAYMENT_VOUCHER_VIEW))) &&
                open &&
                <GoDrawer
                    // minwidth="50%"
                    title={voucherType + " Line"}
                    open={open}
                    onClose={() => onClose()}
                >
                    {/* <VoucherLine
                        voucherType={voucherType}
                        voucherId={voucherId}
                        voucherLineId={voucherLineId}
                        onClose={() => onClose()}
                    /> */}
                </GoDrawer>
            }
            <GoDialog
                open={confirm}
                title=""
                content="Are you sure you want to delete?"
                positive="Yes"
                negative="No"
                handleClose={(res) => handleClose(res)}
            />
        </React.Fragment>
    );
}

export default VoucherLines;